import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import App from 'shell/App'
import { RootStore } from 'RootStore'
import useReactRouterGaReporter from 'tracking/useReactRouterGaReporter'

interface Props {
  rootStore: RootStore
}

const AppRouter = ({ rootStore }: Props) => {
  return (
    <Router>
      <WrappedApp rootStore={rootStore} />
    </Router>
  )
}

const WrappedApp = ({ rootStore }: Props) => {
  useReactRouterGaReporter()

  return (
    <Switch>
      <Route
        path="/invitation/:invitationToken"
        render={(props) => <App {...props} rootStore={rootStore} />}
      />
      <Route render={(props) => <App {...props} rootStore={rootStore} />} />
    </Switch>
  )
}

export default AppRouter
